import { Spacer } from "shared/layout";
import { space } from "shared/styles/constants";
import styled from "styled-components";

export const StyledVenueTeaser = styled.div`
  @media print {
    padding: ${space.s};
    page-break-inside: avoid;
  }
`;

export const StyledVenueSpacer = styled(Spacer)`
  @media print {
    flex: 1;
  }
`;
